import { defineMessages } from 'react-intl';
export default defineMessages({
    E: {
        id: 'compass.E',
        defaultMessage: 'E'
    },
    E_long: {
        id: 'compass.E_long',
        defaultMessage: 'East'
    },
    ENE: {
        id: 'compass.ENE',
        defaultMessage: 'ENE'
    },
    ENE_long: {
        id: 'compass.ENE_long',
        defaultMessage: 'East-Northeast'
    },
    ESE: {
        id: 'compass.ESE',
        defaultMessage: 'ESE'
    },
    ESE_long: {
        id: 'compass.ESE_long',
        defaultMessage: 'East-Southeast'
    },
    N: {
        id: 'compass.N',
        defaultMessage: 'N'
    },
    N_long: {
        id: 'compass.N_long',
        defaultMessage: 'North'
    },
    NE: {
        id: 'compass.NE',
        defaultMessage: 'NE'
    },
    NE_long: {
        id: 'compass.NE_long',
        defaultMessage: 'Northeast'
    },
    NNE: {
        id: 'compass.NNE',
        defaultMessage: 'NNE'
    },
    NNE_long: {
        id: 'compass.NNE_long',
        defaultMessage: 'North-Northeast'
    },
    NNW: {
        id: 'compass.NNW',
        defaultMessage: 'NNW'
    },
    NNW_long: {
        id: 'compass.NNW_long',
        defaultMessage: 'North-Northwest'
    },
    NW: {
        id: 'compass.NW',
        defaultMessage: 'NW'
    },
    NW_long: {
        id: 'compass.NW_long',
        defaultMessage: 'Northwest'
    },
    S: {
        id: 'compass.S',
        defaultMessage: 'S'
    },
    S_long: {
        id: 'compass.S_long',
        defaultMessage: 'South'
    },
    SE: {
        id: 'compass.SE',
        defaultMessage: 'SE'
    },
    SE_long: {
        id: 'compass.SE_long',
        defaultMessage: 'Southeast'
    },
    SSE: {
        id: 'compass.SSE',
        defaultMessage: 'SSE'
    },
    SSE_long: {
        id: 'compass.SSE_long',
        defaultMessage: 'South-Southeast'
    },
    SSW: {
        id: 'compass.SSW',
        defaultMessage: 'SSW'
    },
    SSW_long: {
        id: 'compass.SSW_long',
        defaultMessage: 'South-Southwest'
    },
    SW: {
        id: 'compass.SW',
        defaultMessage: 'SW'
    },
    SW_long: {
        id: 'compass.SW_long',
        defaultMessage: 'Southwest'
    },
    W: {
        id: 'compass.W',
        defaultMessage: 'W'
    },
    W_long: {
        id: 'compass.W_long',
        defaultMessage: 'West'
    },
    WNW: {
        id: 'compass.WNW',
        defaultMessage: 'WNW'
    },
    WNW_long: {
        id: 'compass.WNW_long',
        defaultMessage: 'West-Northwest'
    },
    WSW: {
        id: 'compass.WSW',
        defaultMessage: 'WSW'
    },
    WSW_long: {
        id: 'compass.WSW_long',
        defaultMessage: 'West-Southwest'
    }
});
